require('../images/downarrow.png');
require('../images/leadmatick_blue.png');

require('../images/visio/tutorial-1.jpg');
require('../images/visio/tutorial-2.jpg');
require('../images/visio/tutorial-3.jpg');

require('../images/promoter/sabrina-small-square.jpg');

require("../images/map/ligne14.png");
require("../images/map/ligne15.png");
require("../images/map/ligne16.png");
require("../images/map/ligne17.png");
require("../images/map/ligne18.png");
require("../images/map/location64x64.png");
require("../images/map/eole.png");
